import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { dateTimeParts, dateTimeToIso } from './engageSession';

const HistoryDateDialog = ({ open, value, onClose, onApply, onClear }) => {
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');

  useEffect(() => {
    if (!open) return;
    const parts = dateTimeParts(value);
    setDate(parts.date);
    setTime(parts.time);
  }, [open, value]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth='xs' fullWidth>
      <DialogTitle sx={{ fontWeight: 700 }}>Date and time</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: '8px !important' }}>
        <TextField
          label='Date'
          type='date'
          size='small'
          value={date}
          onChange={(event) => setDate(event.target.value)}
          InputLabelProps={{ shrink: true }}
          inputProps={{ 'aria-label': 'Date' }}
        />
        <TextField
          label='Time'
          type='time'
          size='small'
          value={time}
          onChange={(event) => setTime(event.target.value)}
          InputLabelProps={{ shrink: true }}
          inputProps={{ 'aria-label': 'Time' }}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
        <Button variant='text' onClick={onClear} sx={{ textTransform: 'none', fontWeight: 600, mr: 'auto' }}>
          Clear
        </Button>
        <Button variant='outlined' onClick={onClose} sx={{ textTransform: 'none', fontWeight: 600 }}>
          Cancel
        </Button>
        <Button
          variant='contained'
          disabled={!dateTimeToIso(date, time)}
          onClick={() => onApply(dateTimeToIso(date, time))}
          sx={{ textTransform: 'none', fontWeight: 600 }}
        >
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default HistoryDateDialog;
